import isIAudio from './node/isIAudio';
import isIBanner from './node/isIBanner';
import isICard from './node/isICard';
import isICarousel from './node/isICarousel';
import isICode from './node/isICode';
import isIContainer from './node/isIContainer';
import isIGradedText from './node/isIGradedText';
import isIHeading from './node/isIHeading';
import isIImage from './node/isIImage';
import isILink from './node/isILink';
import isIList from './node/isIList';
import isIModal from './node/isIModal';
import isIPadding from './node/isIPadding';
import isIQuote from './node/isIQuote';
import isIScrollable from './node/isIScrollable';
import isISeparator from './node/isISeparator';
import isISpan from './node/isISpan';
import isIText from './node/isIText';
import isIVideo from './node/isIVideo';
export function visit(node, callbacks) {
    if (callbacks.audio && isIAudio(node)) {
        callbacks.audio(node);
    } else if (callbacks.banner && isIBanner(node)) {
        callbacks.banner(node);
    } else if (callbacks.card && isICard(node)) {
        callbacks.card(node);
    } else if (callbacks.carousel && isICarousel(node)) {
        callbacks.carousel(node);
    } else if (callbacks.container && isIContainer(node)) {
        callbacks.container(node);
    } else if (callbacks.code && isICode(node)) {
        callbacks.code(node);
    } else if (callbacks.gradedText && isIGradedText(node)) {
        callbacks.gradedText(node);
    } else if (callbacks.heading && isIHeading(node)) {
        callbacks.heading(node);
    } else if (callbacks.image && isIImage(node)) {
        callbacks.image(node);
    } else if (callbacks.link && isILink(node)) {
        callbacks.link(node);
    } else if (callbacks.list && isIList(node)) {
        callbacks.list(node);
    } else if (callbacks.modal && isIModal(node)) {
        callbacks.modal(node);
    } else if (callbacks.padding && isIPadding(node)) {
        callbacks.padding(node);
    } else if (callbacks.quote && isIQuote(node)) {
        callbacks.quote(node);
    } else if (callbacks.scrollable && isIScrollable(node)) {
        callbacks.scrollable(node);
    } else if (callbacks.separator && isISeparator(node)) {
        callbacks.separator(node);
    } else if (callbacks.span && isISpan(node)) {
        callbacks.span(node);
    } else if (callbacks.text && isIText(node)) {
        callbacks.text(node);
    } else if (callbacks.video && isIVideo(node)) {
        callbacks.video(node);
    } else if (callbacks.node) {
        callbacks.node(node);
    }
}
export default visit;    //# sourceMappingURL=visit.js.map
